import { useEffect } from 'react'

export const useTransactionStatusUpdater = () => {
  useEffect(() => {
    const checkProcessingTransactions = () => {
      const stored = localStorage.getItem('initiatedTransactions')
      if (!stored) return

      const transactions = JSON.parse(stored)
      let hasUpdates = false

      const updatedTransactions = transactions.map((t: any) => {
        // Check if transaction is in Processing state and 30 seconds have passed
        if (t.status === 'Processing' && t.processingStartTime) {
          const startTime = new Date(t.processingStartTime).getTime()
          const currentTime = new Date().getTime()
          const elapsedSeconds = (currentTime - startTime) / 1000

          if (elapsedSeconds >= 30) {
            hasUpdates = true
            // Update to final status
            return {
              ...t,
              status: 'Completed',
              balanceCheckStatus: 'Passed',
              fundsTransferStatus: 'Completed',
              completedAt: new Date().toISOString(),
              overview: {
                ...t.overview,
                status: 'Completed',
              },
              compliance: {
                ...t.compliance,
                sanctionsCheck: 'Passed',
                amlStatus: 'Clear',
              },
              timeline: t.timeline
                .map((item: any) =>
                  item.title === 'Balance Check'
                    ? {
                        ...item,
                        status: 'completed',
                        timestamp: new Date().toLocaleString(),
                      }
                    : item,
                )
                .concat([
                  {
                    title: 'Funds Transfer',
                    description: 'Funds transferred successfully',
                    timestamp: new Date().toLocaleString(),
                    status: 'completed',
                  },
                  {
                    title: 'Transaction Complete',
                    description: 'Transaction completed successfully',
                    timestamp: new Date().toLocaleString(),
                    status: 'completed',
                  },
                ]),
            }
          }
        }
        return t
      })

      if (hasUpdates) {
        localStorage.setItem(
          'initiatedTransactions',
          JSON.stringify(updatedTransactions),
        )
        window.dispatchEvent(new Event('transactionUpdated'))
      }
    }

    // Check every second
    const interval = setInterval(checkProcessingTransactions, 1000)

    return () => clearInterval(interval)
  }, [])
}
